/**
 * Quick-path split rule (extension-activation-quickpath.md P0-1).
 * Shared by App.tsx's ImportRoute wrapper — kept out of QuickSaveView.tsx so
 * the view file only exports components (react-refresh lint rule).
 */

/** Extension lookups at or below this length skip the document workbench. */
export const QUICK_LOOKUP_MAX_CHARS = 120

/** True when an /app/import deep link should reroute to the quick path. */
export function isQuickLookup(text: string | null, via: string | null): boolean {
  return via === 'extension' && Boolean(text) && (text as string).length <= QUICK_LOOKUP_MAX_CHARS
}
